import React, { useState } from 'react';

export default function HelpButton({ title, children }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button style={styles.button} onClick={() => setOpen(true)} aria-label="Ayuda">
        ❓
      </button>

      {open && (
        <div style={styles.overlay} onClick={e => e.target === e.currentTarget && setOpen(false)}>
          <div style={styles.modal}>
            <div style={styles.header}>
              <h3 style={styles.title}>{title}</h3>
              <button style={styles.closeBtn} onClick={() => setOpen(false)}>✕</button>
            </div>
            <div style={styles.body}>{children}</div>
            <div style={styles.footer}>
              <button className="btn btn-primary" onClick={() => setOpen(false)}>Entendido</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const styles = {
  button: {
    background: 'rgba(201,168,76,0.15)',
    color: 'var(--gold)',
    border: '1px solid var(--border)',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    fontSize: '0.9rem',
    cursor: 'pointer',
    flexShrink: 0,
  },
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 2000, padding: '1.5rem',
  },
  modal: {
    background: 'var(--bg-card)', border: '1px solid var(--border)',
    borderRadius: '16px', width: '100%', maxWidth: '420px',
    maxHeight: '80vh', overflow: 'hidden', display: 'flex', flexDirection: 'column',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '1.1rem 1.25rem', borderBottom: '1px solid var(--border)',
  },
  title: { fontFamily: 'var(--font-display)', color: 'var(--gold)', fontSize: '1.1rem' },
  closeBtn: { background: 'none', color: 'var(--text-muted)', fontSize: '1.1rem', cursor: 'pointer' },
  body: {
    padding: '1.25rem', overflowY: 'auto', color: 'var(--text)',
    fontSize: '0.9rem', lineHeight: 1.6, flex: 1,
  },
  footer: {
    padding: '1rem 1.25rem', borderTop: '1px solid var(--border)',
    display: 'flex', justifyContent: 'flex-end',
  },
};
